import React from "react";
import { Box, Paper, Typography, Avatar } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";

export default function AgentPerformanceWidget({ data }) {
  if (!data) return null;
  const { agents, totalAgents, totalChats, totalMessages } = data;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Typography fontWeight={700} fontSize={15} color="#1e293b" mb={2}>Agent Performance</Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 1.5, mb: 2 }}>
        <MiniStat label="Agents" value={totalAgents} />
        <MiniStat label="Chats" value={totalChats} />
        <MiniStat label="Messages" value={totalMessages} />
      </Box>
      {agents && agents.length > 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {agents.slice(0, 5).map((agent, i) => (
            <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5, borderRadius: 2, bgcolor: "rgba(99,102,241,0.06)" }}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: "#6366f1", fontSize: 12 }}>
                <SupportAgentIcon sx={{ fontSize: 16 }} />
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" color="#1e293b" fontWeight={600} fontSize={13}>Agent {i + 1}</Typography>
                <Box sx={{ display: "flex", gap: 1.5, mt: 0.3 }}>
                  <Typography variant="caption" color="#64748b"><ChatBubbleIcon sx={{ fontSize: 12, mr: 0.3 }} />{agent.totalMessages}</Typography>
                  <Typography variant="caption" color="#64748b"><AccessTimeIcon sx={{ fontSize: 12, mr: 0.3 }} />{agent.avgResponseTime > 60 ? `${Math.round(agent.avgResponseTime / 60)}m` : `${agent.avgResponseTime}s`}</Typography>
                </Box>
              </Box>
              <Typography variant="caption" color="#64748b">{agent.totalChats} chats</Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="#94a3b8" textAlign="center" py={2}>No agent activity yet</Typography>
      )}
    </Paper>
  );
}

function MiniStat({ label, value }) {
  return (
    <Box sx={{ textAlign: "center", p: 1.5, borderRadius: 2, bgcolor: "rgba(99,102,241,0.06)" }}>
      <Typography fontWeight={700} fontSize={18} color="#1e293b">{value}</Typography>
      <Typography variant="caption" color="#64748b" fontWeight={600}>{label}</Typography>
    </Box>
  );
}
